module.exports = __webpack_public_path__ + "static/media/plus-octagon.24279120.svg";